import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getChartColor } from "../../config/colors";

// Accept dispatchData as a prop
const DispatchStatus = ({ dispatchData }) => {
  // Define a set of colors for the slices


  // Transform dispatchData to the format Highcharts expects for a pie chart
  // Assuming dispatchData items have properties like 'class_name' and 'dispatched_count'
  const chartSeriesData = Array.isArray(dispatchData)
    ? dispatchData.map((item) => ({
        name: item.class_name,
        y: item.dispatched_count,
        color: getChartColor(item.class_name), // Use the centralized function
      }))
    : [];

  // Filter out data points with y=0 so they don't appear in the chart
  const filteredChartSeriesData = chartSeriesData.filter((item) => item.y > 0);

  // Calculate the total dispatched count
  const totalDispatchedCount = filteredChartSeriesData.reduce(
    (sum, item) => sum + item.y,
    0
  );

  const options = useMemo(() => ({
    chart: {
      type: "pie",
      height: 250,
      events: {
        render: function () {
          const chart = this;
          const centerX = chart.plotLeft + chart.plotWidth / 2;
          const centerY = chart.plotTop + chart.plotHeight / 2;

          const textHtml = `
            <div style="text-align:center;">
              <span style="font-size: 20px; color: #333333; font-weight: bold;">
                ${totalDispatchedCount}
              </span><br/>
              <span style="font-size: 16px; color: #333333; font-weight: normal;">
                Pairs
              </span>
            </div>
          `;

          // Remove existing text to avoid duplicates on re-render
          if (chart.customCenterText) {
            chart.customCenterText.destroy();
          }

          // Add the text
          chart.customCenterText = chart.renderer
            .label(textHtml, centerX, centerY, null, null, null, true)
            .css({
              color: "#333333",
              textAlign: "center",
            })
            .attr({
              align: "center",
              zIndex: 10,
            })
            .add();

          // Center vertically
          const textBBox = chart.customCenterText.getBBox();
          chart.customCenterText.attr({
            y: centerY - textBBox.height / 2,
          });
        },
      },
    },
    title: {
      text: null,
    },
    tooltip: {
      enabled: true,
      formatter: function () {
        const percentage = (this.point.y / totalDispatchedCount) * 100;
        return (
          `<b style="font-size: 18px;">${percentage.toFixed(1)}%</b><br/>` +
          `Class: <b>${this.point.name}</b><br/>` +
          `Total: <b>${this.point.y}</b><br/>`
        );
      },
    },
    credits: { enabled: false },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: {
        fontWeight: "bold",
        fontSize: "12px",
      },
    },
    exporting: { enabled: false },
    plotOptions: {
      pie: {
        innerSize: "70%", // Donut effect
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "Dispatch Count",
        
        data: filteredChartSeriesData,}
    ],
  }), [dispatchData]);

  return (
    <div style={{ position: "relative", width: "50%", height: "230px" }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default DispatchStatus;